"use client";
import React, { useState, useEffect } from "react";
import image1 from "../../assets/image1.png";
import "./Hero.css";
import { LoginModal } from "./login-modal";

export function HeroSection() {
  const fullText =
    "la solution complète et intelligente pour organiser, gérer et réussir vos réunions.";
  const [text, setText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    if (charIndex < fullText.length) {
      const timer = setTimeout(() => {
        setText((prev) => prev + fullText.charAt(charIndex));
        setCharIndex((prev) => prev + 1);
      }, 40);
      return () => clearTimeout(timer);
    }
  }, [charIndex]);

  const handleLoginClick = () => {
    setShowLoginModal(true);
  };

  return (
    <>
      <section className="hero">
        <div className="hero-content">
          <span className="quote left">"</span>

          <h1 className="hero-title">
            {text}
            <span className="cursor">|</span>
          </h1>

          <span className="quote right">"</span>

          <button className="hero-btn" onClick={handleLoginClick}>
            Se connecter
          </button>
        </div>

        {/* Image en bas */}
        <div className="hero-image">
          <img src={image1} alt="Illustration réunions" priority />
        </div>
      </section>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onSignupClick={() => {
          setShowLoginModal(false);
        }}
      />
    </>
  );
}